import { render, staticRenderFns } from "./MetadataSearch.vue?vue&type=template&id=5af62bcd"
import script from "./MetadataSearch.vue?vue&type=script&lang=js"
export * from "./MetadataSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports